import { SpinnerIcon } from "@phosphor-icons/react";

export const CustomLoader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <SpinnerIcon className="animate-spin text-slate-400" size="80px" />
    </div>
  );
};
